import { Link } from "react-router-dom";

export default function JetLensesHomePage() {
  return (
    <div className="tw-mx-auto tw-flex tw-h-screen tw-max-w-[720px] tw-flex-col tw-justify-center tw-p-[20px]">
      <div className="tw-h-[330px] tw-bg-[url('/homepage/img2.png')] tw-bg-contain tw-bg-bottom tw-bg-no-repeat 840:tw-h-[240px]" />
      <p className="tw-my-[20px] tw-text-center tw-font-serif tw-text-[48px] tw-font-semibold tw-tracking-[-.03px] tw-text-blue-dark-1 840:tw-text-[32px]">
        JetLenses is now Verse Medical.
      </p>
      <p className="tw-text-center tw-font-sans tw-text-[20px] tw-text-gray-2 840:tw-text-[14px]">
        Our team has shifted gears towards{" "}
        <Link to="" className="tw-text-blue-1 tw-underline">
          versemedical.com
        </Link>
        , specializing in Durable Medical Equipment (DME). We are dedicated to
        continuing our mission of providing quality healthcare solutions. <br />
        <br /> JetLenses will no longer accept new orders. We sincerely
        appreciate your support and patronage over the years. For any pending
        orders or inquiries, please contact our customer support team at{" "}
        <a
          href="mailto:customerservice@jetlenses.com"
          className="tw-text-gray-2 tw-underline"
        >
          customerservice@jetlenses.com
        </a>{" "}
        or call us at{" "}
        <a href="tel:1-917-426-9967" className="tw-text-gray-2 tw-underline">
          (917) 426-9967
        </a>
        . We will do our best to assist you during this transition period.
        <br /> <br />
        Thank you for being a part of the JetLenses family.
      </p>
    </div>
  );
}
